import React from 'react';
import './GameBanner.css';

const GameBanner = ({ message, reveal = '', onRestart }) => {
    return (
        <div className="game-banner">
            <div className="banner-content">
                <h2>{message}</h2>
                {reveal && (
                    <p className="reveal">The word was: <strong>{reveal}</strong></p>
                )}
                <button onClick={onRestart}>Restart Game</button>
            </div>
        </div>
    );
};

export default GameBanner;
